import React, { useEffect, useState } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateTreatmentTypeDialog from "./UpdateTreatmentTypeDialog";
import ConfirmationDialog from "../../../../common/components/Dialog";
import {
  deleteTreatmentType,
  getTreatmentTypes,
} from "../../../../api/treatmentTypesApi";
import { StyledButton } from "../../../../common/components/Button";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddTreatmentTypeDialog from "./AddTreatmentTypeDialog";

const TreatmentTypesTable = () => {
  const [openUpdateTreatmentType, setOpenUpdateTreatmentType] = useState(false);
  const [openAddTreatmentType, setOpenAddTreatmentType] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  const [rows, setRows] = useState([]);
  const [currentTreatmentType, setCurrentTreatmentType] = useState({});

  useEffect(() => {
    fetchTreatmentTypes();
  }, []);

  const fetchTreatmentTypes = async () => {
    const response = await getTreatmentTypes();
    console.log(response);
    setRows(response);
  };

  const handleOpenUpdateTreatmentType = (event, params) => {
    event.stopPropagation();
    // if (params.row.name === TreatmentTypes.TreatmentType) {
    //   setCurrentTreatmentType(params.row);
    //   setOpenUpdateTreatmentType(true);
    // }

    setCurrentTreatmentType(params.row);
    setOpenUpdateTreatmentType(true);
  };

  const handleDeleteTreatmentType = async (id) => {
    await deleteTreatmentType({ Id: id });
    // if (response.data.error != null) {
    //   setErrorMessage(response.data.error.message);
    //   handleOpenSnackbar();
    // }
    await fetchTreatmentTypes();
  };

  const handleOpenAddTreatmentType = () => {
    setOpenAddTreatmentType(true);
  };

  const handleCloseAddTreatmentType = () => {
    setOpenAddTreatmentType(false);
  };

  const handleCloseUpdateTreatmentType = () => {
    setOpenUpdateTreatmentType(false);
  };

  const columns = [
    { field: "name", headerName: "Treatment Type", width: 250 },
    { field: "totalPayment", headerName: "Total Payment", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => {
        return [
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faPen} />}
            label="Update"
            onClick={(e) => {
              handleOpenUpdateTreatmentType(e, params);
            }}
          />,
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faTrash} />}
            label="Delete"
            onClick={(e) => {
              e.stopPropagation();
              setShowConfirmationDialog(true);
              setConfirmationSubmit(() => () => {
                handleDeleteTreatmentType(params.id);
                setShowConfirmationDialog(false);
              });
            }}
          />,
        ];
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Treatment Types</StyledH2>
      <StyledButton onClick={handleOpenAddTreatmentType} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add treatment type
      </StyledButton>
      <UpdateTreatmentTypeDialog
        openUpdateTreatmentType={openUpdateTreatmentType}
        handleCloseUpdateTreatmentType={handleCloseUpdateTreatmentType}
        currentTreatmentType={currentTreatmentType}
        fetchTreatmentTypes={fetchTreatmentTypes}
      />

      <AddTreatmentTypeDialog
        openAddTreatmentType={openAddTreatmentType}
        handleCloseAddTreatmentType={handleCloseAddTreatmentType}
        fetchTreatmentTypes={fetchTreatmentTypes}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete selected treatment plan?"}
      />
      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default TreatmentTypesTable;
